import { Popover } from "@mui/material";
import { Timer } from "../entities";
import { KronosTimerForm } from "./kronosTimerForm";

/**
 *
 * @returns {ReactElement} KronosTimerPopper page
 */
export function KronosTimerPopper({
  anchorEl,
  open,
  onClose,
  timer,
  onChange,
}: KronosTimerPopperType) {
  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      sx={{ mt: 1 }}
    >
      <KronosTimerForm timer={timer} onChange={onChange} />
    </Popover>
  );
}

type KronosTimerPopperType = {
  anchorEl?: Element | undefined;
  timer?: Timer;
  open: boolean;
  onClose: () => void;
  onChange: (t: Partial<Timer>) => void;
};
